<template>
    <div>
        <headline>Einstellungen</headline>

        <group-code class="mb-8"></group-code>

        <mail-filter class="mb-8"></mail-filter>

        <mail-cumulate class="mb-8"></mail-cumulate>

        <slot-settings class="mb-8"></slot-settings>

        <store-open class="mb-8"></store-open>

        <app-header class="mb-8"></app-header>

        <has-friends-on-map class="mb-8"></has-friends-on-map>

        <saml-mapping class="mb-8"></saml-mapping>
    </div>
</template>

<script>
import MailFilter from "../components/Settings/MailFilter";
import GroupCode from "../components/Settings/GroupCode";
import StoreOpen from "../components/Settings/StoreOpen";
import SlotSettings from "../components/SlotSettings";
import Headline from "../components/UI/Headline.vue";
import AppHeader from "../components/Settings/AppHeader.vue";
import MailCumulate from "../components/Settings/MailCumulate.vue";
import HasFriendsOnMap from "../components/Settings/HasFriendsOnMap.vue";
import SamlMapping from "../components/Settings/SamlMapping.vue";

export default {
    name: "Settings",
    components: {
        SamlMapping,
        HasFriendsOnMap,
        MailCumulate,
        AppHeader,
        Headline,
        SlotSettings,
        StoreOpen,
        GroupCode,
        MailFilter,
    }
}
</script>

<style scoped>

</style>
